import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import PanelWrapper from "~/components/PanelWrapper";
import Tooltip from "~/shared/ui/Fields/Tooltip";
import { DATA_STATUS_TYPES } from "~/constans/statuses";
import { ManagerIProps } from "~/entity/Dealer/model/schema";
import { getCallableNumber, getShortUserName } from "~/libs/getData";

import s from "./BlockManagement.less";

interface IProps {
  loading: boolean;
  data: ManagerIProps;
}

const BlockManagement: FC<IProps> = ({ loading, data }) => {
  const { t } = useTranslation();

  const { name, phone, mphone, email, photo } = data;

  const formatHeadName = getShortUserName(name);
  const formatHeadPhone = getCallableNumber(phone);
  const formatHeadMobilePhone = getCallableNumber(mphone);

  return (
    <PanelWrapper
      width={408}
      height={120}
      drainsDown
      label={t("management.management")}
      customClassName={s.no_padding}
      loading={loading && !!data}
    >
      <div className={s.manage}>
        <div className={s.manage_line}>
          <div className={s.manage_block}>
            <div className={s.user}>
              <div className={s.user__img}>
                {photo?.link && <img alt="img" src={photo.link} />}
              </div>
              <div className={s.text}>
                <div>
                  <strong>{formatHeadName || "..."}</strong>
                  <div> {"генеральный директор"}</div>
                </div>
                <div className={s.phonesWrapp}>
                  <ul className={s.phones}>
                    <li>
                      <Tooltip
                        hoverable
                        text={phone || DATA_STATUS_TYPES.ND}
                        variant="bottom"
                      >
                        <div className={s.phone}>
                          <a href={`tel:${formatHeadPhone}`}>
                            {" "}
                            {phone || DATA_STATUS_TYPES.ND}{" "}
                          </a>
                        </div>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        hoverable
                        text={mphone || DATA_STATUS_TYPES.ND}
                        variant="bottom"
                      >
                        <div className={s.phone}>
                          <a href={`tel:${formatHeadMobilePhone}`}>
                            {mphone || DATA_STATUS_TYPES.ND}
                          </a>
                        </div>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        hoverable
                        text={email || DATA_STATUS_TYPES.ND}
                        variant="bottom"
                      >
                        <div className={s.email}>
                          <a href={`mailto:${email}`}>
                            {" "}
                            {email || DATA_STATUS_TYPES.ND}{" "}
                          </a>
                        </div>
                      </Tooltip>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PanelWrapper>
  );
};

export default BlockManagement;
